import { IndicatorManager } from '../manager/IndicatorManager';
import { IndicatorDescriptor, IndicatorParams } from '../manager/types';

export interface IndicatorControllerOptions { manager: IndicatorManager }
export class IndicatorController { private manager: IndicatorManager; constructor(opts:IndicatorControllerOptions){ this.manager=opts.manager; }
 list(): IndicatorDescriptor[]{ return this.manager.listIndicators(); }
 add(type:string, placement:'overlay'|'separate'='separate'){ const defaults:Record<string,IndicatorParams>={ moving_average:{ period:50 }, RSI:{ period:14 }, macd:{ fastMAPeriod:12, slowMAPeriod:26, signalPeriod:9 }, prediction_lr:{ lookbackPeriod:50, projectionBars:20 } }; const params=defaults[type]||{}; return this.manager.addIndicator(type, params, placement); }
 remove(id:string){ this.manager.removeIndicator(id); }
 clear(){ this.manager.removeAll(); }
 highlight(id:string, styleOverrides?:Record<string,unknown>){ this.manager.highlight(id, styleOverrides); }
 clearHighlight(id:string){ this.manager.clearHighlight(id); }
 serializeLayout(){ return this.manager.serializeLayout(); }
 restoreLayout(layout:any){ this.manager.restoreLayout(layout); }
}
export default IndicatorController;
